export const callToAPI = async (routeUrl, methodData, headerContent) => {
  const res = await fetch(routeUrl, {
    method: methodData,
    headers: headerContent,
  });

  return res;
};
